import { IRequestParams, IResultContent, request } from "@fanfanlo";
import { tms } from "../tms";
import { IRequestOptions } from "../IRequestOptions";

/**
 * @description 获取邀请状态的请求参数
 */
export interface IEmcGetInviteStatusParams extends IRequestParams {
    invite_ids: string[];
}

/**
 * @description 单个邀请的状态
 */
export interface IEmcInviteStatusItem {
    invite_id: string;
    status: 'pending' | 'accepted' | 'declined' | 'expired';
}

/**
 * @description 获取邀请状态的完整响应体
 */
export interface IEmcGetInviteStatusResult extends IResultContent {
    results: IEmcInviteStatusItem[];
}

/**
 * @description 调用获取邀请状态接口的函数
 * @param opts 包含 params, gateway, handler 的请求选项
 */
export async function tmsEmcGetInviteStatus(opts: IRequestOptions<IEmcGetInviteStatusParams>) {
    const res = await request<IEmcGetInviteStatusResult>(tms.TEmc, tms.MEmcGetInviteStatus, opts.params, opts.gateway, opts.handler);
    return res;
}
